import React from 'react';
import Marquee from '../../../components/ui/Marquee';

const trustItems = [
  '🔥 2000+ Students Trained',
  '⭐ 5 Rating',
  '🌍 10+ Countries',
  '💪 Expert Coaching',
  '🏆 Proven Results',
  '🎯 Personalized Plans',
  '📱 Train Anywhere',
  '🤝 Community Support',
];

const MarqueeSection = () => {
  return (
    <section className="py-8 md:py-12 overflow-hidden">
      <div className="space-y-4">
        <Marquee speed={35} direction="left" pauseOnHover>
          {trustItems.map((item, i) => (
            <span
              key={i}
              className="inline-flex items-center px-5 py-2.5 text-sm font-medium glass rounded-pill whitespace-nowrap text-[var(--color-text-primary)]"
            >
              {item}
            </span>
          ))}
        </Marquee>

        <Marquee speed={40} direction="right" pauseOnHover>
          {[...trustItems].reverse().map((item, i) => (
            <span
              key={i}
              className="inline-flex items-center px-5 py-2.5 text-sm font-medium glass rounded-pill whitespace-nowrap text-[var(--color-text-primary)]"
            >
              {item}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default MarqueeSection;
